module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/jszip/~/core-js/library/modules/_property-desc.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_property-desc.js
// module chunks = 3